import {
  Dimensions,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  FIREBASE_EVENT_NAMES,
  FIREBASE_EVENT_PARAMS,
  PAGES_ROUTES,
  PAGES_TITLE,
} from "utils/Constants";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { getOrderSummary, removeCoupon } from "appRedux/reducers/orderSlice";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import CheckoutCard from "components/checkout/CheckoutCard";
import { Colors } from "colors";
import { FONTS_SIZES } from "fonts";
import ImageView from "../src/image";
import { Images } from "assets";
import Loader from "components/Loader";
import ParentScrollView from "components/ParentScrollView";
import Payment from "./payment";
import PromoCode from "components/checkout/PromoCode";
import SavedCardsComp from "components/checkout/saveCardsCop";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { getCart } from "appRedux/reducers/cartSlice";
import { getFormatedCurrency } from "utils/common";
import { getUserSavedCards } from "appRedux/reducers/profileSlice";
import { logEvent } from "firebase/analytics";
import { t } from "i18next";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";

export const SLIDER_WIDTH = Dimensions.get("window").width;
export const ITEM_WIDTH = SLIDER_WIDTH;

const OrderSummary = ({}) => {
  const [loader, setLoader] = useState(false);
  const [paymentCardsList, setPaymentCardsList] = useState([]);
  const cartDataItems = useSelector((state) => state.CartReducer.cart);
  const orderSummary = useSelector((state) => state.OrderReducer.orderSummary);
  const orderCoupon = useSelector((state) => state.OrderReducer.orderCoupon);
  const userId = useSelector((state) => state.AuthReducer.userId);
  const deliveryAddress = useSelector(
    (state) => state.OrderReducer.deliveryAddress
  );
  const billingAddress = useSelector(
    (state) => state.OrderReducer.billingAddress
  );
  const country = useSelector((state) => state.StoredutilsSlice.country);
  const countrySymbol = useSelector(
    (state) => state.StoredutilsSlice.countrySymbol
  );
  const [selectedCard, setSelectedCard] = useState(null);

  const local = useLocalSearchParams();
  const gender = local?.gender || "female";
  const userStatus = userId ? "logged_in" : "guest";

  const dispatch = useDispatch();

  useEffect(() => {
    const deliveryOptions = [];
    orderSummary?.products?.forEach((item) => {
      deliveryOptions.push(item?.selectedShippingMethod?.displayName);
    });

    const eventData = {
      shipping_address: deliveryAddress?.type,
      billing_address: billingAddress?.type,
      user_status: userStatus,
      bag_product_count: cartDataItems?.cart?.length,
      bag_total_value: cartDataItems?.orderSummary?.totalAmount,
      delivery_option: JSON.stringify(deliveryOptions),
    };
    trackV2(ANALYTICS_EVENT_NAMES.REVIEW_SHIPPING_BILLING_ADDRESS, eventData);
    fetchSavedCards();
  }, [
    billingAddress.name,
    billingAddress?.type,
    cartDataItems?.cart?.length,
    cartDataItems?.orderSummary?.totalAmount,
    deliveryAddress,
    deliveryAddress.name,
    fetchSavedCards,
    orderSummary?.products,
    userStatus,
  ]);

  const fetchSavedCards = useCallback(() => {
    // setLoader(true);
    dispatch(getUserSavedCards())
      .then((res) => {
        // setLoader(false);
        if ([200].includes(res?.payload?.status)) {
          setPaymentCardsList(res?.payload?.data?.bankDetailsList);
        }
      })
      .catch((err) => {
        // setLoader(false);
        // showToast("Error");
        console.log("err", err);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCart());
    return () => {
      dispatch(removeCoupon());
    };
  }, [dispatch]);

  useEffect(() => {
    if (
      Array.isArray(cartDataItems?.cart) &&
      cartDataItems?.cart?.length > 0 &&
      deliveryAddress?.id &&
      cartDataItems?.orderSummary?.totalAmount
    ) {
      dispatch(
        getOrderSummary({
          addressId: deliveryAddress?.id,
          products: cartDataItems?.cart
            ?.filter((o) => o?.isAvailable)
            ?.map((o) => {
              // Create a copy of the object and remove the shippingMethods key
              const { shippingMethods, selectedShippingMethod, ...rest } = o;
              let id = rest?.product?.id;
              let temp = { id: id, ...rest };
              const matchingProduct =
                orderSummary &&
                orderSummary?.products?.find((item) => item.productId === id);
              if (matchingProduct) {
                // Set selectedShippingMethod from orderSummary if available
                temp.selectedShippingMethod =
                  matchingProduct.selectedShippingMethod?.name;
              }

              delete temp.product;
              return temp;
            }),
          totalAmount: cartDataItems?.orderSummary?.totalAmount,
          userId: userId,
        })
      );
    }
  }, [
    cartDataItems,
    deliveryAddress?.id,
    deliveryAddress?.id.totalAmount,
    dispatch,
    userId,
  ]);

  const RenderItem = ({ data, idx }) => {
    const { product } = data;
    const { id } = product;
    let shippingMethods = [];
    let deliverytypeName = "";

    if (
      orderSummary &&
      orderSummary.products &&
      orderSummary.products.length > 0
    ) {
      orderSummary?.products.forEach((item) => {
        if (id === item?.productId) {
          shippingMethods = item?.shippingMethods;
          deliverytypeName = item?.selectedShippingMethod?.name;
        }
      });
    }

    if (product?.affiliateBrandName && product?.affiliateLink) {
      return <></>;
    }

    return (
      <CheckoutCard
        containerStyle={{
          marginBottom: spV(32),
          borderBottomWidth: 1,
          paddingBottom: spV(32),
          borderColor: "rgba(33, 36, 39, 0.3)",
        }}
        idx={idx}
        shippingMethods={shippingMethods}
        deliveryType={deliverytypeName}
        hideCross={false}
        hideOptions={!data?.isAvailable}
        isCheckout={true}
        cartItem={data}
        isOrderSummaryCall={true}
      />
    );
  };

  const AddressDeliveryView = () => {
    return (
      <View
        style={[
          {
            backgroundColor: "white",
          },
        ]}
      >
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <View style={Styles.billingTextView}>
            <VText
              style={[
                Styles.orderText,
                {
                  fontSize: fp(16),
                  color: "#333333",
                  marginBottom: 5,
                },
              ]}
            >
              {`Delivery address : `}
              <VText
                style={{
                  fontWeight: "550",
                }}
              >
                {deliveryAddress?.name}
              </VText>
            </VText>

            <VText
              style={[
                Styles.boldText,
                {
                  fontSize: fp(16),
                  color: "#212427",
                  marginBottom: 5,
                  fontWeight: "350",
                },
              ]}
            >
              {deliveryAddress?.type}
            </VText>
            <VText
              style={[
                Styles.addressText,
                {
                  fontSize: fp(16),
                  color: "#666666",
                  marginBottom: 5,
                },
              ]}
            >
              {`${deliveryAddress?.addressLine1} ${deliveryAddress?.addressLine2} ${deliveryAddress?.city}, ${deliveryAddress?.state} ${deliveryAddress?.pincode}, ${deliveryAddress?.country}`}
            </VText>
          </View>

          <TouchableOpacity
            onPress={() => {
              router.push(`${gender == "men" ? "/men" : ""}/addresslist`);
            }}
            style={Styles.changeAddressButton}
          >
            <VText
              style={{
                fontSize: fp(16),
              }}
            >
              {"Change"}
            </VText>
          </TouchableOpacity>
        </View>
        <View style={[Styles.billingTextView, { paddingTop: spV(20) }]}>
          <VText
            style={[
              Styles.orderText,
              {
                fontSize: fp(16),
                color: "#333333",
                marginBottom: 5,
              },
            ]}
          >
            {"Billing address : "}
            <VText
              style={{
                fontWeight: "550",
              }}
            >
              {billingAddress?.name}
            </VText>
          </VText>

          <VText
            style={[
              Styles.boldText,
              {
                fontSize: fp(16),
                color: "#212427",
                marginBottom: 5,
                fontWeight: "350",
              },
            ]}
          >
            {billingAddress?.type}
          </VText>
          <VText
            style={[
              Styles.addressText,
              {
                fontSize: fp(16),
                color: "#666666",
                marginBottom: 5,
              },
            ]}
          >
            {`${billingAddress?.addressLine1} ${billingAddress?.addressLine2} ${billingAddress?.city}, ${billingAddress?.state} ${billingAddress?.pincode}, ${billingAddress?.country}`}
          </VText>
        </View>
        <View
          style={{
            paddingBottom: hp(12),
            borderBottomWidth: 1,
            borderColor: "rgba(33, 36, 39, 0.3)",
            marginBottom: hp(38),
            marginTop: hp(20),
          }}
        >
          <VText
            style={{
              fontSize: fp(20),
              color: "rgba(33, 36, 39, 1)",
              fontFamily: "LibreBodoni",
            }}
          >
            Review Products
          </VText>
        </View>
      </View>
    );
  };

  const PriceBreakUpView = () => {
    const noOfProducts =
      cartDataItems?.cart?.filter(
        (o) =>
          o?.isAvailable &&
          !o?.product?.affiliateBrandName &&
          !o?.product?.affiliateLink
      )?.length || 0;
    return (
      <>
        <View style={Styles.priceBreakupContainer}>
          <VText style={Styles.priceBreakupText}>Price Breakup</VText>
          <View style={Styles.rowContainer}>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >{`Subtotal  (${noOfProducts} ${
              noOfProducts == 1 ? "Product" : "Products"
            } )`}</VText>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >{`${countrySymbol}${getFormatedCurrency(
              orderSummary?.totalAmount
            )}`}</VText>
          </View>
          <View style={[Styles.rowContainer, { paddingTop: 10 }]}>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >
              {"Shipping Charges"}
            </VText>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >{`${countrySymbol}${getFormatedCurrency(
              orderSummary?.deliveryCharge || 0
            )}`}</VText>
          </View>
          <View style={[Styles.rowContainer, { paddingTop: 10 }]}>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >
              {"Sales Tax"}
            </VText>
            <VText
              style={{
                fontSize: fp(14),
                color: "rgba(33, 36, 39, 1)",
              }}
            >{`${countrySymbol}${getFormatedCurrency(
              orderSummary?.taxAmount || 0
            )}`}</VText>
          </View>
          {orderCoupon && (
            <View style={[Styles.rowContainer, { paddingTop: 10 }]}>
              <VText
                style={{
                  fontSize: fp(14),
                  color: "rgba(33, 36, 39, 1)",
                }}
              >{`${"Promotion"} (${orderCoupon?.code})`}</VText>
              <VText
                style={{
                  fontSize: fp(14),
                  color: "rgba(33, 36, 39, 1)",
                }}
              >{`-${countrySymbol}${getFormatedCurrency(
                orderCoupon?.discountAmount || 0
              )}`}</VText>
            </View>
          )}
          <View style={[Styles.rowContainer, { paddingTop: 10 }]}>
            <VText style={Styles.boldText}>{"Order Total"}</VText>
            <VText
              style={Styles.boldText}
            >{`${countrySymbol}${getFormatedCurrency(
              orderSummary?.payableAmount -
                (orderCoupon?.discountAmount || 0) || 0
            )}`}</VText>
          </View>
        </View>
        <View
          style={{
            paddingBottom: hp(18),
            borderBottomWidth: 1,
            borderColor: "rgba(33, 36, 39, 0.3)",
            paddingTop: hp(25),
          }}
        >
          <VText
            style={{
              fontSize: fp(20),
              color: "rgba(33, 36, 39, 1)",
              fontFamily: "LibreBodoni",
            }}
          >
            Payment Method
          </VText>
        </View>

        {paymentCardsList?.length > 0 && (
          <>
            <VText
              style={{
                fontSize: fp(16),
                color: "#2124274D",
                fontWeight: "350",
                paddingTop: hp(20),
              }}
            >
              SAVED CARDS
            </VText>

            <View style={{ paddingTop: hp(10) }}>
              {paymentCardsList?.map((item) => {
                return (
                  <SavedCardsComp
                    key={item?.customerProfileId}
                    item={item}
                    selectedCard={selectedCard}
                    onPressCard={(card) =>
                      setSelectedCard((prev) => (prev === card ? null : card))
                    }
                  />
                );
              })}
            </View>
            <VText
              style={{
                fontSize: fp(16),
                color: "#2124274D",
                fontWeight: "350",
                paddingTop: hp(20),
              }}
            >
              ADD OTHER
            </VText>
          </>
        )}
        <View
          style={{
            borderWidth: 1,
            borderColor: "#00000033",
            padding: 16,
            marginTop: 16,
            flexDirection: "row",
            alignItems: "center",
          }}
          activeOpacity={1}
        >
          <Svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <G clipPath="url(#clip0_8468_45094)">
              <Path
                d="M28 5.73279V22.2673C28 23.3336 27.1353 24.1983 26.069 24.1983H1.93103C0.864741 24.1983 0 23.3336 0 22.2673V5.73279C0 4.6665 0.864741 3.80176 1.93103 3.80176H26.069C27.1353 3.80176 28 4.6665 28 5.73279Z"
                fill="#ADC6FF"
              />
              <Path
                d="M7.96336 17.2585H3.92026C3.65365 17.2585 3.4375 17.0423 3.4375 16.7757C3.4375 16.5091 3.65365 16.293 3.92026 16.293H7.96336C8.22996 16.293 8.44611 16.5091 8.44611 16.7757C8.44611 17.0423 8.22996 17.2585 7.96336 17.2585Z"
                fill="white"
              />
              <Path
                d="M7.96336 20.2761H3.92026C3.65365 20.2761 3.4375 20.0599 3.4375 19.7933C3.4375 19.5267 3.65365 19.3105 3.92026 19.3105H7.96336C8.22996 19.3105 8.44611 19.5267 8.44611 19.7933C8.44611 20.0599 8.22996 20.2761 7.96336 20.2761Z"
                fill="white"
              />
              <Path
                d="M25.1011 18.2842C25.1011 19.4175 24.1827 20.336 23.0494 20.336C22.4526 20.336 21.9155 20.0813 21.5408 19.6746C20.2833 21.0393 17.9805 20.1534 17.9805 18.2842C17.9805 16.4128 20.2845 15.5303 21.5408 16.8939C21.9155 16.4872 22.4526 16.2325 23.0494 16.2325C24.1827 16.2325 25.1011 17.151 25.1011 18.2842Z"
                fill="#F4B619"
              />
              <Path
                d="M20.0322 20.3359C21.1653 20.3359 22.0839 19.4173 22.0839 18.2841C22.0839 17.151 21.1653 16.2324 20.0322 16.2324C18.8991 16.2324 17.9805 17.151 17.9805 18.2841C17.9805 19.4173 18.8991 20.3359 20.0322 20.3359Z"
                fill="#EE7212"
              />
              <Path d="M0 8.14648H28V12.2499H0V8.14648Z" fill="#5585F8" />
            </G>
            <Defs>
              <ClipPath id="clip0_8468_45094">
                <Rect width="28" height="28" fill="white" />
              </ClipPath>
            </Defs>
          </Svg>

          <VText
            Text
            style={{
              fontSize: fp(16),
              fontWeight: "550",
              color: "#333333",
              paddingLeft: 15,
            }}
          >
            Credit / Debit Card
            <VText
              style={{
                fontSize: 14,
                color: "#212427B2",
                display: "block",
                paddingTop: 10,
              }}
            >
              Pay with your Visa, Mastercard, American Express and more
            </VText>
          </VText>
        </View>
        <Payment
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </>
    );
  };

  const Visa = () => (
    <Svg width={50} height={50} viewBox="0 0 750 471">
      <G fill="none" fillRule="evenodd">
        <Rect fill="#0E4595" width="750" height="471" rx="40" />
        <Path
          fill="#FFFFFF"
          d="M278.1975 334.2275 311.5585 138.4655 364.9175 138.4655 331.5335 334.2275"
        ></Path>
      </G>
    </Svg>
  );

  const Mastercard = () => (
    <Svg width={50} height={50} viewBox="0 0 750 471">
      <G fill="none" fillRule="evenodd">
        <Rect fill="#000000" width="750" height="471" rx="40" />
        <G>
          <Rect
            fill="#FF5F00"
            x="170.55"
            y="32.39"
            width="143.72"
            height="234.42"
          />
          <Path
            d="M185.05 149.6 C185.05997 103.912554 205.96046 60.7376085 241.79 32.39 ..."
            fill="#EB001B"
          />
        </G>
      </G>
    </Svg>
  );

  const AmexIcon = () => (
    <Svg width={50} height={50} viewBox="0 0 750 471">
      <G fill="none" fillRule="evenodd">
        <Rect fill="#2557D6" width="750" height="471" rx="40" />
        <Path
          fill="#FFFFFF"
          d="M554.594 130.608l-14.521 35.039h29.121L554.594 130.608z M387.03 152.321c2.738-1.422 4.349-4.515 ..."
        />
      </G>
    </Svg>
  );

  return (
    <ParentScrollView>
      <View
        style={{
          flex: 1,
          paddingLeft: spH(200),
          paddingTop: spV(32),
          paddingBottom: spV(28),
          width: wp(652),
        }}
      >
        <View
          style={{
            paddingBottom: hp(18),
            borderBottomWidth: 1,
            borderColor: "rgba(33, 36, 39, 0.3)",
            marginBottom: hp(16),
          }}
        >
          <VText
            style={{
              fontSize: fp(20),
              color: "rgba(33, 36, 39, 1)",
              fontFamily: "LibreBodoni",
            }}
          >
            Shipping & Billing Details
          </VText>
        </View>

        {cartDataItems?.cart && cartDataItems?.cart?.length > 0 && (
          <View>
            <AddressDeliveryView />
            {Array.isArray(cartDataItems?.cart) &&
              cartDataItems?.cart
                ?.filter((o) => o?.isAvailable)
                ?.map((o, idx) => {
                  return <RenderItem data={o} idx={idx} key={idx} />;
                })}
            <>
              <PromoCode />
              <View
                style={{
                  paddingBottom: hp(18),
                  borderBottomWidth: 1,
                  borderColor: "rgba(33, 36, 39, 0.3)",
                  paddingTop: hp(28),
                  zIndex: -100,
                }}
              >
                <VText
                  style={{
                    fontSize: fp(20),
                    color: "rgba(33, 36, 39, 1)",
                    fontFamily: "LibreBodoni",
                  }}
                >
                  Price Summary
                </VText>
              </View>
              <PriceBreakUpView />
            </>
          </View>
        )}
        {!cartDataItems?.cart ||
          (cartDataItems?.cart?.length == 0 && (
            <View style={Styles.parentContainer}>
              <ImageView
                source={Images.cartEmpty}
                style={Styles.searchWebIcon}
              />
              <View style={Styles.emptyTextContainer}>
                <VText style={Styles.emptyText}>
                  You haven’t placed any orders
                </VText>
                <VText
                  style={[
                    Styles.emptyText,
                    {
                      color: "#999999",
                      fontSize: 13,
                    },
                  ]}
                >
                  All your orders will appear here
                </VText>
                <TouchableOpacity
                  onPress={() => {
                    router.push(`/${gender == "men" ? "/men" : ""}`);
                  }}
                  style={Styles.btn}
                >
                  <VText style={Styles.btnText1}>Browse Catalog</VText>
                </TouchableOpacity>
              </View>
            </View>
          ))}
        <Loader loading={loader} />
      </View>
    </ParentScrollView>
  );
};

export default OrderSummary;

const Styles = StyleSheet.create({
  priceBreakupContainer: {
    marginTop: spV(10),
    backgroundColor: Colors.white,
    zIndex: -100,
  },
  orderText: {
    fontWeight: "350",
    fontSize: FONTS_SIZES.s4,
    color: Colors.greyText,
  },
  addressText: {
    width: "85%",
    fontWeight: "350",
    fontSize: 15,
    color: Colors.black60,
  },
  billingTextView: {
    width: "75%",
  },
  billingText: {
    fontWeight: "350",
    fontSize: 15,
    color: Colors.black60,
  },
  btnText: {
    fontSize: FONTS_SIZES.s14,
    fontWeight: "550",
    marginLeft: wp(5),
  },
  parentContainer: {
    alignItems: "center",
  },
  searchWebIcon: {
    height: 120,
    width: 120,
    marginTop: spV(60),
  },
  emptyTextContainer: {
    alignItems: "center",
    marginTop: spV(15),
  },
  emptyText: {
    fontWeight: "350",
    fontSize: 15,
    color: "#333333",
    marginTop: spV(5),
  },
  btn: {
    alignItems: "center",
    justifyContent: "center",
    width: spH(160),
    height: spV(40),
    marginTop: spV(20),
    borderRadius: 10,
    backgroundColor: Colors.black,
  },
  btnText1: {
    fontSize: FONTS_SIZES.s14,
    fontWeight: "550",
    color: Colors.white,
  },
  changeAddressButton: {
    paddingHorizontal: spH(20),
    alignItems: "center",
    justifyContent: "center",
    height: hp(30),
    borderWidth: 1,
    borderColor: Colors.black,
  },
  rowContainer: {
    flexDirection: "row",
    marginTop: spV(3),
    justifyContent: "space-between",
    alignItems: "center",
  },
  greyText: {
    fontWeight: "350",
    fontSize: FONTS_SIZES.s4,
    color: Colors.greyText,
  },
  priceBreakupText: {
    color: Colors.black,
    fontWeight: "350",
    marginBottom: spV(12),
    marginTop: 5,
    fontSize: 16,
  },
  boldText: {
    color: Colors.black,
    fontWeight: "550",
    fontSize: 16,
  },
});
